import { useState, useCallback } from 'react'
import { api } from '../utils/apiComponent/apiClient'
import { endpoints } from '../utils/endpoints'

export function useCourseEnrollments() {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  // Lister tous les utilisateurs d'un cours (admin)
  const getCourseUsers = useCallback(async (courseId, filters = {}) => {
    setLoading(true)
    setError(null)
    
    try {
      const params = new URLSearchParams()
      
      if (filters.page) params.append('page', filters.page.toString())
      if (filters.limit) params.append('limit', filters.limit.toString())
      if (filters.status) params.append('status', filters.status)
      if (filters.search) params.append('search', filters.search)
      
      const queryString = params.toString()
      const url = queryString 
        ? `${endpoints.adminCourseUsers(courseId)}?${queryString}` 
        : endpoints.adminCourseUsers(courseId)
      
      const response = await api.get(url)
      return response
    } catch (err) {
      const errorMessage = err?.message || "Erreur lors de la récupération des utilisateurs"
      setError(errorMessage)
      throw err
    } finally {
      setLoading(false)
    }
  }, [])

  // Gérer l'accès d'un utilisateur à un cours (admin)
  const updateEnrollmentAccess = useCallback(async (enrollmentId, accessData) => {
    setLoading(true)
    setError(null)
    
    try {
      const response = await api.patch(
        endpoints.adminEnrollmentAccess(enrollmentId),
        accessData
      )
      return response
    } catch (err) {
      const errorMessage = err?.message || "Erreur lors de la mise à jour de l'accès"
      setError(errorMessage)
      throw err
    } finally {
      setLoading(false)
    }
  }, [])

  // Retirer un utilisateur d'un cours (admin)
  const deleteEnrollment = useCallback(async (enrollmentId) => {
    setLoading(true)
    setError(null)
    
    try {
      const response = await api.delete(endpoints.adminDeleteEnrollment(enrollmentId))
      return response
    } catch (err) {
      const errorMessage = err?.message || "Erreur lors de la suppression de l'inscription"
      setError(errorMessage)
      throw err
    } finally {
      setLoading(false)
    }
  }, [])

  // Activer un cours pour des utilisateurs spécifiques (admin)
  const activateCourseForUsers = useCallback(async (courseId, userIds, accessDurationDays = null) => {
    setLoading(true)
    setError(null)
    
    try {
      const body = {
        courseId,
        userIds
      }
      
      if (accessDurationDays !== null) {
        body.accessDurationDays = accessDurationDays
      }
      
      const response = await api.post(endpoints.adminActivateCourse, body)
      return response
    } catch (err) {
      const errorMessage = err?.message || "Erreur lors de l'activation du cours"
      setError(errorMessage)
      throw err
    } finally {
      setLoading(false)
    }
  }, [])

  return {
    loading,
    error,
    getCourseUsers,
    updateEnrollmentAccess,
    deleteEnrollment,
    activateCourseForUsers
  }
}

